export const selectOptions = {
    showLabels: false,
    hideSelected: false,
    key: 'id',
    trackBy: 'id',
    label: 'name',
  };

  export const arrayOptions = {
    type: 'array',
    // showRemoveButton: true,
    removeElementButtonLabel: 'X',
    removeElementButtonClasses: 'vs-button vs-component vs-button-primary vs-button-flat remove-button',
    newElementButtonLabel: 'Add',
    newElementButtonLabelClasses: 'vs-button vs-component vs-button-primary vs-button-filled add-button',
    fieldClasses: 'form-array-editor',
  };

  export const datepickerOptions = {
    pikadayOptions: {
      format: 'DD/MM/YYYY',

    },
    type: 'pikaday',

    // This is done to not revert back to Jan 1st 1970 when removing the input value
    set: function(field, value) {
      if (value === false) {
        return null;
      }

      field[this.model] = value;
    }
  };

  class FormElement {

    static select() {
      return JSON.parse(JSON.stringify(selectOptions));
    }

  }

  export default FormElement;
